import { render, staticRenderFns } from "./History_mobileAdmin.vue?vue&type=template&id=e1de1104&"
import script from "./History_mobileAdmin.vue?vue&type=script&lang=js&"
export * from "./History_mobileAdmin.vue?vue&type=script&lang=js&"
import style0 from "./History_mobileAdmin.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports